import { gql, useMutation } from "@apollo/client";
import { useForm, FormProvider } from "react-hook-form";
import { VERIFY_HORSE_PREV_OWNERSHIP } from "apollo/mutations/horses";

import Button from "components/Buttons";
import ModalStore from "components/Modal/ModalStore";
import { HorseOwnershipSchema } from "../Schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "components/ui/input";

const OwnershipEmailForm = ({ inputHorseData }) => {
  const [verifyHorsePrevOwnership, { loading }] = useMutation(
    gql(VERIFY_HORSE_PREV_OWNERSHIP)
  );

  const methods = useForm({
    resolver: zodResolver(HorseOwnershipSchema),
    defaultValues: {
      email: "",
    },
  });

  const onSubmitEmail = async (data) => {
    try {
      await verifyHorsePrevOwnership({
        variables: {
          input: {
            ...inputHorseData,
            email: data?.email,
          },
        },
        refetchQueries: ["listUserHorses"],
      });
      ModalStore.closeAll();
      setTimeout(() => {
        ModalStore.openSimpleError({
          fontSize: "40px",
          title: "Ownership Verified Successfully",
          shouldCloseOnOverlayClick: false,
        });
      }, 1000);
    } catch (error) {
      ModalStore.openSimpleError({
        icon: undefined,
        title: "Error",
        subtitle: error?.message,
        shouldCloseOnOverlayClick: false,
      });
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmitEmail)}>
        <div className="flex flex-col items-center gap-y-[25px]">
          <div>
            <Input
              label="Email:"
              name="email"
              placeholder="Enter Your Email"
              className="horse-profile-form__field w-[210px] sm:!w-[340px]"
              {...methods.register("email")}
            />
            {methods.formState.errors.email && (
             <span className="text-red-500 text-sm font-montserrat mt-1">
                {methods.formState.errors.email.message}
              </span>
            )}
          </div>
          <Button
            className="horse-add-save-btn !w-[150px] !h-[56px] sm:!w-[182px]"
            primary
            whiteOutline
            loading={loading}
            type="submit"
          >
            Save
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default OwnershipEmailForm;
